// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__0SAcw","modal":"Modal_modal__rZcsn","header":"Modal_header__ax5Ta","content":"Modal_content__yLV36"};